import React from 'react';

import './Page.css';


class PageRavens extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

  }



  render() {

    const tab = "    "
  

    return (
          
    <main className='pages-body'>

        <section className='pages-section-h1 responsive-text'>
          <h1 className='responsive-text responsive-text-h1'>RAVENS DER-CAM API Documentation</h1>
        </section>
        <section className='pages-section responsive-text'>
            <h2>Introduction</h2>
            <p>
              This document provides a guide to using the RAVENS model schema for DER-CAM (Distributed Energy Resource - Customer Adoption Model) modeling, via the DER-CAM API. 
              <br/> <br/>
              DER-CAM utilizes a subset of inputs defined in the RAVENS model, including load profiles, energy prices, and DER asset options (solar PV, battery, generators) and outage scenarios. These inputs are used to model and optimize a microgrid energy system that minimizes the expected cost while delivering the specified level of resilience.  DER-CAM results will be added into the RAVENS model in specific fields for use by other integrated models or directly by users.
              <br/> <br/>
              The RAVENS integrated DER-CAM model is available via an existing API. Instructions for using this service are outlined below. A free DER-CAM user account is required to access the API. You may create an account by visiting https://dercam-app.lbl.gov 
            </p>
          </section>

          <section className='pages-section-h1 responsive-text'>
            <h1 className='responsive-text responsive-text-h1'>Using the RAVENS DER-CAM API</h1>
          </section>

          <section className='pages-section responsive-text'>
            <h2>API Endpoints</h2>
            <p>
              The API offers a number of functions for interacting with the DER-CAM server via HTTP requests:
            </p>
            <ul>
              <li>Sending a model to the server</li>
              <li>Retrieving the status of a submitted model</li>
              <li>Retrieving results data of a successfully solved model</li>
            </ul>
            <p>
              You may use your preferred method to execute your HTTP requests. Example Python code for each of the primary API functions are outlined below.
              <br/><br/>
              For all requests, you will need to define the base URL of the DER-CAM API, along with your API key, which is accessible when logged into an active DER-CAM web-app account.
              </p>
              <pre><code>
                # import the python requests library<br/>
                import requests as req <br/>
                <br/>
                # define API base URL and your own API key<br/>
                urlBase = 'https://microgrids1.lbl.gov:4000/api/wkey/ravens' <br/>
                userKey = ‘your_api_key’ <br/>
              </code></pre>

              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Submitting your RAVENS model</h2>
            <p>
              You can send your RAVENS model to the DER-CAM server via the endpoint:
            </p>

            <code class="endpoint">POST https://microgrids1.lbl.gov:4000/api/wkey/ravens/your_api_key</code>
           
            <p>
             You will need to include within the body of your request the RAVENS model. Note the model data must also include a user-defined model name. Below is an example of using the model submission endpoint, using Python:
            </p>

            <pre><code>
                # define url for POST request<br/>
                url = f'&#123;urlBase&#125;/&#123;userKey&#125;'<br/>
                <br/><br/>
                # add a model label and version to be included in data object (required)<br/>
                data=&#123;<br/>
                    {tab}'name': "Ravens Dev Test Model",<br/>
                    {tab}'model': modelData<br/>
                &#125; <br/>
                <br/>
                # POST request returns data for new model<br/>
                response = req.post(url=url, json=data)<br/>
                <br/>
                # myNewModel = response.json()['model']

              </code></pre>

              <p>
              You may check the status of your request by examining the response.status_code or response.reason, which should register 200 Created, if successful. Additionally, your response should include metadata for your newly created model, including a unique model key used to retrieve the status and results of that model.
              </p>

              <pre><code>
                # check metadata for new model<br/>
                myNewModel = response.json()['model']
              </code></pre>

              <p>
              This object should now contain the following data describing the newly submitted model.
              </p>

              <pre><code>
                &#123; <br/>
                 {tab}'model_key': '2060cf6c691', <br/>
                 {tab}'type': 'ravens',<br/>
                 {tab}'version': '0',<br/>
                 {tab}'label': 'Ravens Dev Test Model',<br/>
                 {tab}'datetime_added': '2025-01-01 05:05:05',<br/>
                 {tab}'datetime_executed': None,<br/>
                 {tab}'status': 'queued',<br/>
                 {tab}'results_available': 0,<br/>
                 {tab}'expiration': None,<br/>
                 {tab}'solve_status': None,<br/>
                 {tab}'solve_time': None,<br/>
                 {tab}'msg': None,<br/>
                 {tab}'in_trash': 0,<br/>
                {tab}'datetime_deleted': None<br/>
                &#125; 
              </code></pre>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Checking your RAVENS model status</h2>
            <p>
              After initial submission, your model will be added to the queue of the DER-CAM server. While solve times will vary based on the complexity of the model and the volume of current users, your DER-CAM model should likely be solved within a few minutes. You can check the status of your model at any time using the following API endpoint. Recall that your model key is returned in the response body of your initial submission request.
            </p>

            <code class="endpoint">GET https://microgrids1.lbl.gov:4000/api/wkey/ravens/your_api_key/status/model_key</code>
           
            <p>
            Here’s an example of using this endpoint to get a model’s current status:
            </p>

            <pre><code>
                # define url by appending model key to 'status' endpoint<br/>
                url = f'&#123;urlBase&#125;/&#123;userKey&#125;/status/&#123;modelKey&#125;'<br/>
                <br/>
                # model info and status will be returned in 'model' field<br/>
                response = req.get(url)<br/>
                myExistingModel = response.json()['model']<br/>
                <br/>
                myExistingModel
            </code></pre>

             <p>
              This returns a similar object as when creating a new model. However, the existing model metadata reflects the current status of the model and can be used to check when the model has been solved.
            </p>

            <pre><code>
                &#123; <br/>
                 {tab}'model_key': '2060cf6c691', <br/>
                 {tab}'type': 'ravens',<br/>
                 {tab}'version': '0',<br/>
                 {tab}'label': 'Ravens Dev Test Model',<br/>
                 {tab}'datetime_added': '2025-01-01 05:05:05',<br/>
                 {tab}'datetime_executed': '2025-01-01 05:06:00',<br/>
                 {tab}'status': 'solved',<br/>
                 {tab}'results_available': 1,<br/>
                 {tab}'expiration': '2025-01-06 05:05:05',<br/>
                 {tab}'solve_status': 'GAMS optimization successfully solved',<br/>
                 {tab}'solve_time': 16.143,<br/>
                 {tab}'msg': 'RAVENS optimization and processing successful',<br/>
                 {tab}'in_trash': 0,<br/>
                {tab}'datetime_deleted': None<br/>
                &#125; 
              </code></pre>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Downloading your RAVENS model results</h2>
            <p>
              Once the field ‘status’ returns as “solved”, your model’s results can be retrieved from the server. Use your same model key, and the following endpoint to download the full RAVENS model, with added DER-CAM results from the server.
            </p>

            <code class="endpoint">GET https://microgrids1.lbl.gov:4000/api/wkey/ravens/your_api_key/results/model_key</code>
           
            <p>
            Example code for using this endpoint is as follows:
            </p>

            <pre><code>
                # define url by appending model key to 'results' endpoint<br/>
                url = f'&#123;urlBase&#125;/&#123;userKey&#125;/results/&#123;modelKey&#125;'<br/>
                <br/>
                # model info and status will be returned in 'model' field<br/>
                response = req.get(url)<br/>
                <br/>
                # extract ravens model from der-cam server reponse<br/>
                ravensModel = response.json()['model']['results']['resultsJson']<br/>
            </code></pre>

             <p>
              A successful request will return your updated RAVENS model, along with some additional metadata describing the DER-CAM server operations. To access only the RAVENS model data, use the location described above within the response JSON body
            </p>
              
          </section>

          <section className='pages-section-h1 responsive-text'>
            <h1 className='responsive-text responsive-text-h1'>Defining RAVENS DER-CAM Model Inputs</h1>
          </section>

          <section className='pages-section responsive-text'>
            <h2>Key Model Inputs</h2>
            <p>
              To generate meaningful results from DER-CAM, several input types are necessary. These key input fields are summarized below, with some notes on how they are interpreted by the DER-CAM model. Other RAVENS inputs are not directly utilized to construct or optimize DER-CAM models.
            </p>

            <p>
              The required inputs are:
            </p>
            <ul>
              <li>Load Profile(s)</li>
              <li>Energy Prices</li>
              <li>DER Proposed Asset Options</li>
              <li>Outage Scenarios (Optional)</li>
            </ul>

            <p>
              While the RAVENS schema allows users to define inputs with different units and time-resolutions, the DER-CAM input parser has limited flexibility on handling inputs beyond their expected format and units. Please refer to the description of RAVENS inputs below when constructing a DER-CAM model. If inputs do not conform with these expectations, errors may be introduced into the subsequent DER-CAM results, or the model run may fail entirely.
            </p>
              
          </section>



          <section className='pages-section responsive-text'>
            <h2>Load Profiles</h2>
            <p>
              RAVENS allows for the definition of individual Energy Consumer load profiles through two different methods. The DER-CAM API can currently handle both of these definition schemes, described below.
            </p>

            <p>
              To determine which method should be used in the RAVENS input processing, the DER-CAM parser examines the objects listed in the top-level field BasicIntervalScedule. If this object contains a unit for the field BasicIntervalSchedule.value1Unit (Note: the expected unit for this field for DER-CAM is UnitSumbol.W), then the parser will proceed with method 1. If there is no unit listed in this first entry of BasicIntervalSchedule, then the parser will assume to use the Scaled Unit-less Method 2 instead.
            </p>

            <h2>Method 1 - Individual Load Profiles:</h2>
            <p>
              Under this method, each EnergyConsumer has a corresponding load profile, describing its energy consumption for each hour of a year of operation. The DER-CAM model will aggregate the load profiles of each EnergyConsumer included in any load group defined in the  Group field,  used to  define the subset of EnergyConsumer objects that comprise the microgrid. If no load group is provided, all EnergyConsumers will be used to create the aggregated load profile.
            </p>

            <p>
              Expected parameters of BasicIntervalSchedule objects:
            </p>

            <ul>
              <li>Time-Resolution: h</li>
              <li>Units: W</li>
              <li>Number of values: 8760</li>
              <li>Number of objects: 1 of each EnergyConsumer to include in model</li>
            </ul>


            <h2>Method 2 - Scaled Unitless Profile:</h2>
            <p>
              Under this method, each individual EnergyConsumer does not have their own unique load profile defined in BasicIntervalSchedule. Instead, a single unitless BasicIntervalSchedule object is defined to describe the load shape of the full system/feeder.
            </p>

            <p>
             Within the subfield [‘PowerSystemResource’][‘Equipment’][‘ConductingEquipment’][‘EnergyConsumer’] the maximum power of the individual Energy Consumer is defined in field EnergyConsumer.p.
             This field is used to scale the system-wide profile to that specific energy consumer. Consequently, under this method, all EnergyConsumers will have the same energy consumption load shape, but differing load magnitude
            </p>

            <p>
              Expected parameters of BasicIntervalSchedule objects:
            </p>

            <ul>
              <li>Time-Resolution: h</li>
              <li>Units: None</li>
              <li>Number of values: 8760</li>
              <li>Number of objects: 1 (single profile for full system)</li>
            </ul>

            <p>
              Expected parameters of ‘EnergyConsumer’ objects:
            </p>

            <ul>
              <li>Time-Resolution: None</li>
              <li>Units: W (for field EnergyConsumer.p)</li>
              <li>Number of values: 1</li>
              <li>Number of objects: 1 of each EnergyConsumer to include in model</li>
            </ul>

            
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Energy Prices</h2>
            <p>
              DER-CAM generally operates from the perspective of a utility customer, minimizing their energy costs when interacting with a utility. In the context of RAVENS models, DER-CAM can use the locational marginal price (LMP) as an approximation of the energy cost for electricity for energy consumers within the system.
            </p>

            <p>
              DER-CAM extracts the first object provided in the “LocationalMarginalPrice” object found in the “EnergyPrices” field of the RAVENS model. Here, DER-CAM expects to find an hourly price curve describing approximate energy prices for each hour of the year, in units of $ per kWh. This annual profile will be extracted and used to construct expected hourly “real-time-price” values for electricity, used directly by DER-CAM.
            </p>

            <p>
              If the number of points varies from the expected 8760, or if a different unit for the energy price is used, DER-CAM may not interpret and process the input correctly.
            </p>

            <p>
              Expected parameters of LocationalMarginalPrice objects:
            </p>

            <ul>
              <li>Time-Resolution: h</li>
              <li>Units: $ per kWh</li>
              <li>Number of values: 8760</li>
              <li>Number of objects: 1 (single profile for full system)</li>
            </ul>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Capacity Price</h2>
            <p>
              DER-CAM can likewise use the RAVENS input for capacity prices as a proxy for a power demand charge experienced by energy consumers within the modeled system. Here, DER-CAM will parse the first object found in the sub-field “CapacityPrices” of the field “EnergyPrices”. Within this object, DER-CAM will extract the first point of the price curve. This value will be assumed as the non-coincident demand charged applied to the aggregate system. Only the first value in the curve will be used, and other values will be neglected. 
            </p>

            <p>
              Expected parameters of CapacityPrice objects:
            </p>

            <ul>
              <li>Time-Resolution: None</li>
              <li>Units: $ per kW</li>
              <li>Number of values: 1</li>
              <li>Number of objects: 1 (single profile for full system)</li>
            </ul>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>DER Proposed Asset Options:</h2>
            <p>
              Here you must define the DER asset options that can be considered for adoption. The RAVENS-compatible version of DER-CAM is capable of considering DER types: solar photovoltaic (PV), battery energy storage systems (BESS), and generators (genset). While these different DER types share some structural similarities in the RAVENS schema, the process of defining each individual type is provided below.
            </p>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>PV Asset Options:</h2>
            <p>
              Within the RAVENS field ProposedAssetOptions, users may define an option for installing PV. Below is an example definition of a PV asset option. 
            </p>

            <pre><code>
                "proposedPV1": &#123;<br/>
                {tab}"Ravens.cimObjectType": "ProposedPhotoVoltaicUnitOption",<br/>
                {tab}"IdentifiedObject.mRID": "d6910f52-7455-4074-9d94-e0851cf131db",<br/>
                {tab}"IdentifiedObject.name": "proposedPV1",<br/>
                {tab}"ProposedAssetOption.ProposedConnectivityNodes": [<br/>
                    {tab}{tab}"ConnectivityNode::'670'"<br/>
                {tab}],<br/>
                {tab}"ProposedAssetOption.ProposedLocations": [<br/>
                    {tab}{tab}"ProposedSiteLocations::'proposedSite1'"<br/>
                {tab}],<br/>
                {tab}"ProposedAssetOption.lifetime": "P25Y",<br/>
                {tab}"ProposedEnergyProducerOption.operationsAndMaintenanceRateVariable": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.operationsAndMaintenanceRateFixed": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedEnergyProducerOption.powerCapacityMax": 1000000.0,<br/>
                {tab}"ProposedEnergyProducerOption.powerCapacityMin": 0.0,<br/>
                {tab}"ProposedEnergyProducerOption.variablePrice": &#123;<br/>
                    {tab}{tab}"value": 2200.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.fixedPrice": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedPhotoVoltaicUnitOption.GenerationProfile": "Curve::'proposedPV1_dispatch'"<br/>
            &#125;<br/>
            </code></pre>

            <p>Some notes for defining your own PV asset option:</p>
            <ul>
              <li>DER-CAM requires a lifetime, variable price, and reference to a generation profile. All other inputs are optional or can be populated by default values</li>
              <li>The generation profile must reference a curve object containing the hourly normalized PV generation in units of W generated per W of capacity</li>
              <li>The variable price is assumed to represent $ per kW of installed capacity. Fixed price is an optional input, and is applied to the capital cost of the DER asset option, regardless of the capacity selected.</li>
              <li>The total selected capacity can be constrained using the maximum and minimum power capacity fields</li>
              <li>Operations and Maintenance (O&M) costs can also be specified. Fixed  O&M costs scale with the asset’s capacity ($ per kW capacity per year), while variable O&M costs scale with the asset’s usage ($ per kWh produced per year).</li>
            </ul>
              
          </section>



         <section className='pages-section responsive-text'>
            <h2>BESS Asset Options:</h2>
            <p>
             Within the RAVENS field ProposedAssetOptions, users may define an option for installing BESS. Below is an example definition of a BESS asset option. 
            </p>

            <pre><code>

            "proposedESS1": &#123;<br/>
                {tab}"Ravens.cimObjectType": "ProposedBatteryUnitOption",<br/>
                {tab}"IdentifiedObject.mRID": "1d9844ba-def2-42dc-8580-52f9dc5a8686",<br/>
                {tab}"IdentifiedObject.name": "proposedESS1",<br/>
                {tab}"ProposedAssetOption.ProposedLocations": [<br/>
                    {tab}{tab}"ProposedSiteLocations::'proposedSite1'"<br/>
                {tab}],<br/>
                {tab}"ProposedAssetOption.fixedPrice": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.operationsAndMaintenanceRateFixed": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.lifetime": "P25Y",<br/>
                {tab}"ProposedBatteryUnitOption.energyDurationMax": 2,<br/>
                {tab}"ProposedEnergyProducerOption.powerCapacityMin": 50000.0,<br/>
                {tab}"ProposedEnergyProducerOption.powerCapacityMax": 150000.0,<br/>
                {tab}"ProposedBatteryUnitOption.stateOfChargeMin": 20.0,<br/>
                {tab}"ProposedBatteryUnitOption.stateOfChargeMax": 100.0,<br/>
                {tab}"ProposedBatteryUnitOption.chargeEfficiency": 92.0,<br/>
                {tab}"ProposedBatteryUnitOption.dischargeEfficiency": 92.0,<br/>
                {tab}"ProposedBatteryUnitOption.decayRate": 0.5,              <br/>
                {tab}"ProposedEnergyProducerOption.variablePrice": &#123;<br/>
                    {tab}{tab}"value": 500.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedEnergyProducerOption.operationsAndMaintenanceRateVariable": &#123;<br/>
                    {tab}{tab}"value": 0.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;<br/>
            &#125;<br/>

               
            </code></pre>

            <p>Some notes for defining your own BESS asset option:</p>
            <ul>
              <li>DER-CAM requires a lifetime, variable price, and storage operational parameters (e.g. efficiency, SOC limits) . All other inputs are optional or can be populated by default values. </li>
              <li>RAVENS inputs not shown above are not used by DER-CAM to define BESS options</li>
              <li>The variable price is assumed to represent $ per kW of installed capacity. Fixed price is an optional input, and is applied to the capital cost of the DER asset option, regardless of the capacity selected.</li>
              <li>The total selected capacity can be constrained using the maximum and minimum power capacity fields</li>
              <li>Operations and Maintenance (O&M) costs can also be specified. Fixed  O&M costs scale with the asset’s capacity ($ per kW capacity per year), while variable O&M costs scale with the asset’s usage ($ per kWh produced per year).</li>
              <li>The relationship between BESS energy and power is defined in the field “energyDurationMax” which should define the battery duration at maximum output. In the example above, the 2 hour duration would mean 1 kW of charging/discharging power per every 2 kWh of installed BESS energy capacity.</li>
            </ul>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Genset Asset Options:</h2>
            <p>
             Within the RAVENS field ProposedAssetOptions, users may define an option for installing Genset. Below is an example definition of a Genset asset option. 
            </p>

            <pre><code>

            "Genset1": &#123;<br/>
                {tab}"Ravens.cimObjectType": "ProposedGeneratingUnitOption",<br/>
                {tab}"IdentifiedObject.mRID": "6ad66b81-e6d0-4b08-b797-5356df1622bc",<br/>
                {tab}"IdentifiedObject.name": "Genset1",<br/>
                {tab}"ProposedAssetOption.variablePrice": &#123;<br/>
                    {tab}{tab}"value": 2500.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.operationsAndMaintenanceRateFixed": &#123;<br/>
                    {tab}{tab}"value": 10.0,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedAssetOption.operationsAndMaintenanceRateVariable": &#123;<br/>
                    {tab}{tab}"value": 0.01,<br/>
                    {tab}{tab}"unit": "Currency.USD"<br/>
                {tab}&#125;,<br/>
                {tab}"ProposedGeneratingUnitOption.numUnitsMin": 1,<br/>
                {tab}"ProposedGeneratingUnitOption.numUnitsMax": 3,<br/>
                {tab}"ProposedAssetOption.lifetime": "P15Y",<br/>
                {tab}"ProposedGeneratingUnitOption.unitEfficiency": 25.0,<br/>
                {tab}"ProposedGeneratingUnitOption.combinedHeatPowerEnabled": false,<br/>
            &#125;<br/>

            </code></pre>

            <p>Some notes for defining your own Genset asset option:</p>
            <ul>

              <li>DER-CAM requires a lifetime, unit price, and efficiency. All other inputs are optional or can be populated by default values. </li>
              <li>RAVENS inputs not shown above are not used by DER-CAM to define Genset options</li>
              <li>The unit price represents the cost per kW of capacity of individual genset units. Units can only be adopted in discrete amounts</li>
              <li>The total selected units can be constrained using the maximum and minimum unit fields</li>
              <li>Operations and Maintenance (O&M) costs can also be specified. Fixed  O&M costs scale with the asset’s capacity ($ per kW capacity per year), while variable O&M costs scale with the asset’s usage ($ per kWh produced per year).</li>
              <li>Gensets can also be specified as combined heat and power units, using the above field combinedHeatPowerEnabled. </li>

            
             </ul>
              
          </section>

          <section className='pages-section responsive-text'>
            <h2>Outage Scenarios:</h2>
            <p>
             You can introduce outage events into your model using the Outage Scenario inputs. This will force the DER-CAM model to adopt DER options for resilience as well as for cost reduction. An example of outage scenarios, defined in the RAVENS model field “OutageScenario”, is provided below.
           </p>

            <pre><code>

              "OutageScenario": &#123;<br/>
                {tab}"outagescenario01": &#123;<br/>
                    {tab}{tab}"OutageScenario.loadFractionCritical": 50.0,<br/>
                    {tab}{tab}"OutageScenario.loadFractionTotal": 20.0,<br/>
                    {tab}{tab}"OutageScenario.anticipatedStartDay": "--08-12",<br/>
                    {tab}{tab}"OutageScenario.anticipatedDuration": "P48H",<br/>
                    {tab}{tab}"OutageScenario.anticipatedStartHour": 14,<br/>
                    {tab}{tab}"IdentifiedObject.name": "outagescenario01",<br/>
                    {tab}{tab}"IdentifiedObject.mRID": "3dc75f27-42ab-40ce-a019-67e7cf09d707"<br/>
                {tab}&#125;,<br/>
                {tab}"outagescenario02": &#123;<br/>
                    {tab}{tab}"OutageScenario.loadFractionCritical": 50.0,<br/>
                    {tab}{tab}"OutageScenario.loadFractionTotal": 30.0,<br/>
                    {tab}{tab}"OutageScenario.anticipatedStartDay": "--01-17",<br/>
                    {tab}{tab}"OutageScenario.anticipatedDuration": "P48H",<br/>
                    {tab}{tab}"OutageScenario.anticipatedStartHour": 9,<br/>
                    {tab}{tab}"IdentifiedObject.name": "outagescenario02",<br/>
                    {tab}{tab}"IdentifiedObject.mRID": "34e98fc7-4034-466e-b858-8e8d9535f1f1"<br/>
                {tab}&#125;,<br/>
              &#125;<br/>

            </code></pre>

            <p>Some notes for defining your own Outage Scenario:</p>
            <ul>

              <li>DER-CAM utilizes the fields “anticipatedStartDay”, “anticipatedDuration”, and “loadFractionCritical”</li>
              <li>Because DER-CAM uses representative design days, some approximations must be used to model outages</li>
              <li>Outage durations should typically be provided as partial day events ({'<'}24 hours) or as multiple full-day events.</li>
              <li>For the outage date provided, DER-CAM will determine the day-type it corresponds to: typical week-day, weekend day, or peak-load day</li>
              <li>DER-CAM will require electricity service for the fraction of load defined in loadFractionCritical. The remaining load will be shed by the model (i.e. not served by the system). No cost for shedding non-critical load will be imposed.</li>

            
             </ul>
              
          </section>

          <section className='pages-section-h1 responsive-text'>
            <h1 className='responsive-text responsive-text-h1'>Parsing RAVENS DER-CAM Model Results</h1>
          </section>

          <section className='pages-section responsive-text'>
            
            <p>
             The principal operation performed by DER-CAM is to assess the DER proposed asset options, and select and size the portfolio of DER assets that (1) reduce the total energy-related costs of the system, and (2) satisfy any resilience requirements defined in the models outage scenario inputs. In completing this operation, DER-CAM will create and populate fields in the RAVENS model returned by the server. All added fields will be clearly labeled with “DERCAM” prefixes, to distinguish them from outputs originating from separate models. A summary of these output fields, with some guidance on interpreting each is provided below:
           </p>

            <h2>Application</h2>
            <p>
             DER-CAM adds summary data to this RAVENS field, indicating that a DER-CAM optimization has been performed on the model file.
            </p>

             <h2>Message</h2>
            <p>
             A brief set of log statements is added to the RAVENS field “Message”. Please refer to this to understand how the DER-CAM server processes the model. Additionally, if results fail or contain unexpected values, the added message text may help to understand any errors experienced by the DER-CAM server.
            </p>

             <h2>ProposedAssetSet</h2>
            <p>
             Here a list of any adopted ProposedAssetOptions is generated. Only assets with non-zero adopted capacity will be listed. Any proposed asset not adopted will not be referenced.
            </p>

             <h2>ProposedAsset</h2>
            <p>
             Here, individual descriptions and capacities of adopted ProposedAssetOptions will be added. Each new ProposedAsset item will include references to related EstimatedCost and Curve entries, which describe the costs and dispatch patterns , respectively, of the given DER asset.
            </p>

             <h2>EstimatedCost</h2>
            <p>
             Estimates for each adopted DER asset total capital costs [$], and expected annual financing cost (described as a lifecycle cost) [$/yr] are provided. For non-adopted DER assets, no EstimateCost entry will be created.
            </p>

             <h2>Curve</h2>
            <p>
             Here, the expected power dispatch schedule [kW or kW per hour] for each adopted DER is provided. While DER-CAM uses discrete design days, an estimate for the full year is reconstructed. Thus, each Curve series constitutes 8760 hourly values, representing the full year. Sign convention is used to represent loads as positive, and generation as negative. For non-adopted DER assets, no Curve entry will be created.

            </p>

          </section>

       
    </main>
          
    )
  }
}

export default PageRavens;
